export default __webpack_public_path__ + "static/media/MongoDB-Atlas.fad6f852.png";